{
	"Subtype_Adventure": "Adventure",
	"Subtype_Arcane": "Arcane",
	"Subtype_Lesson": "Lesson",
	"Subtype_Trap": "Trap"
}